import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import HttpError from '@common/interfaces/api/http-error';
import RestSet, { defaultRestSet } from '@common/interfaces/api/rest-set';
import ValidationResult from '@common/interfaces/api/validation-result';
import FleetDashboard from 'models/fleet-management/FleetDashboard';
import FleetDataConfiguration from 'models/fleet-management/FleetDataConfiguration';

interface FleetManagementState {
  dashboards: {
    data: FleetDashboard[] | null;
    rest: RestSet;
    selectedId: string | null;
  };
  datasets: {
    data: FleetDataConfiguration | null;
    rest: RestSet;
  };
  live: {
    id: string;
    loadTime: number | null;
    /** When the current answer landed (epoch ms), so a live query knows when to ask again. */
    fetchedAt?: number | null;
    data: any | null;
    rest: {
      getStatus: HttpFetchStatus;
      getError: HttpError | ValidationResult[] | null;
    };
  }[];
}

export const defaultCurrentDashboardState = {
  id: null,
  hasChanges: false,
  data: null,
  rest: { getStatus: HttpFetchStatus.Idle, getError: null },
};

export const getInitialFleetManagementState = (): FleetManagementState => {
  return {
    dashboards: {
      data: null,
      rest: defaultRestSet,
      selectedId: null,
    },
    datasets: {
      data: null,
      rest: defaultRestSet,
    },
    live: [],
  };
};
export type { FleetManagementState };
